import { memo } from "react";
import { clsx } from "clsx";

import type { ReactNode } from "react";

export interface SheetModalBodyProps {
  children?: ReactNode;
  className?: string;
}
export const SheetModalBody = memo(function SheetModalBody({
  children,
  className,
}: SheetModalBodyProps) {
  return <div className={clsx("SheetModalBody", className)}>{children}</div>;
});
